// sets up a simple in-memory buffer for location updates, to be flushed when the socket is ready

interface BufferedPayload {
  latitude: number;
  longitude: number;
  accuracy?: number;
  heading?: number;
  speed?: number;
  timestamp: string;
}

const MAX_BUFFER = 500;

class LocationBuffer {
  private buffer: BufferedPayload[] = [];

  push(payload: BufferedPayload): void {
    this.buffer.push(payload);
    if (this.buffer.length > MAX_BUFFER) {
      this.buffer = this.buffer.slice(-MAX_BUFFER);
    }
  }

  flush(): BufferedPayload[] {
    const items = [...this.buffer];
    this.buffer = [];
    return items;
  }

  get size(): number {
    return this.buffer.length;
  }
}

export const locationBuffer = new LocationBuffer();
